






























































import {Component, Prop, Watch} from 'vue-property-decorator';
import ChunForm from '@/mixins/ChunForm';
import {VFormData} from '@/utils/VFormData';
import ShopCollectionSelect from '@/components/ShopCollectionSelect.vue';
import ProductSelect from '@/components/ProductSelect.vue';
import {IFacebookPixel} from '@/models/IFacebookPixel';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';
import {createFacebookPixel, updateFacebookPixel} from '@/services/FacebookPixelService';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';

interface IFacebookPixelFormData {
  facebook_pixel_id: string;
  capi_token: string;
  enabled: boolean;
  is_all_page: boolean;
  shop_collections: number[];
  products: number[];
  capi_enabled: boolean;
}

@Component({
  components: {
    ShopCollectionSelect, ProductSelect
  }
})
export default class FacebookPixelForm extends ChunForm {
  @Prop() facebookPixel: IFacebookPixel;
  @Prop({default: false}) isEdit!: boolean;
  loading: boolean = false;

  formData: VFormData<IFacebookPixelFormData> = new VFormData<IFacebookPixelFormData>(
      {
        facebook_pixel_id: '',
        capi_token: '',
        enabled: false,
        is_all_page: false,
        shop_collections: [],
        products: [],
        capi_enabled: false,
      }
  );

  @Watch('facebookPixel', {immediate: true})
  onFacebookPixelChange() {
    if (this.facebookPixel) {
      this.formData.data.facebook_pixel_id = this.facebookPixel.facebook_pixel_id;
      this.formData.data.capi_token = this.facebookPixel.capi_token;
      this.formData.data.enabled = this.facebookPixel.enabled;
      this.formData.data.is_all_page = this.facebookPixel.is_all_page;
      this.formData.data.capi_enabled = this.facebookPixel.capi_enabled;
      this.formData.data.products = this.facebookPixel.products.map((item) => item.id);
      this.formData.data.shop_collections = this.facebookPixel.shop_collections.map((item) => item.id);
    }
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  async create() {
    try {
      this.loading = true;
      const res = await createFacebookPixel(this.organizationId, this.shopId, this.formData.data.facebook_pixel_id,
          this.formData.data.enabled, this.formData.data.capi_token, this.formData.data.is_all_page, this.formData.data.capi_enabled,
          this.formData.data.products, this.formData.data.shop_collections);
      if (res.status === 422) {
        this.extractError(res);
        return;
      }
      if (res.status === 200) {
        await this.$router.replace({name: 'dashboard.facebook-pixel-management'});
        LayoutModule.showNotification({text: 'Success'});
      } else {
        LayoutModule.showNotification({text: res.data.message, type: NotificationType.ERROR});
        return;
      }
    } finally {
      this.loading = false;
    }
  }

  async edit() {
    try {
      const res = await updateFacebookPixel(this.organizationId, this.shopId, this.facebookPixel.id,
          this.formData.data.enabled, this.formData.data.capi_token, this.formData.data.is_all_page, this.formData.data.capi_enabled,
          this.formData.data.products, this.formData.data.shop_collections);
      if (res.status === 422) {
        this.extractError(res);
        return;
      }
      if (res.status === 200) {
        await this.$router.replace({name: 'dashboard.facebook-pixel-management'});
        LayoutModule.showNotification({text: 'Success'});
      } else {
        LayoutModule.showNotification({text: res.data.message, type: NotificationType.ERROR});
        return;
      }
    } finally {
      this.loading = false;
    }
  }
}
